export default __webpack_public_path__ + "static/media/budvue-screenshot.1f412643.png";